/*
 * Patches SAT.Logic.prototype.__schedule (assets/sat-runtime.js) to add a
 * setTimeout fallback alongside its existing requestAnimationFrame call.
 *
 * Every setState/forceUpdate across the whole app funnels through this one
 * method, shaped like: set __pending = true, wait for a single rAF callback
 * to flip __pending back to false and run the real render. While __pending
 * is true, every other setState/forceUpdate call just returns immediately
 * (`if (this.__pending) return;`) — correct, so several updates in the same
 * tick coalesce into one render instead of one each.
 *
 * The bug this fixes: requestAnimationFrame's callback isn't guaranteed to
 * fire on any schedule when the tab isn't the browser's actively-composited
 * page — backgrounded even briefly, minimized, or paused by the browser's
 * own tab-discarding/power-saving policies (Chrome's Memory Saver and
 * similar background-tab throttling are common, not edge cases). If that
 * one scheduled rAF callback never runs, __pending is stuck true forever —
 * not just for whatever change was in flight, for every re-render the app
 * would ever try to do again, since __schedule's guard clause keeps bailing
 * out early on it. Confirmed live: SATApp.state.boardStep kept advancing
 * correctly the whole time — startBoardWave (assets/sat-board-wave-patch.js)
 * and every other setTimeout-driven wave loop in this codebase were doing
 * their job — while the DOM sat frozen on whatever it had last painted,
 * because the one render that would have flushed it never got its turn.
 * That's what actually reads as "janky, not fluid, not flush": the board
 * isn't fighting its own timing, the paint just isn't happening.
 *
 * Fixed with a plain setTimeout racing the same rAF call — whichever fires
 * first wins (the other is a no-op via the `fired` guard), so a
 * well-behaved foreground tab still renders on rAF's own clock exactly as
 * before, and a stalled one self-heals within 100ms instead of staying
 * frozen until a full page reload.
 */
(function () {
  'use strict';
  if (!window.SAT || !window.SAT.Logic || typeof window.SAT.Logic.prototype.__schedule !== 'function') { return; }

  window.SAT.Logic.prototype.__schedule = function (cb) {
    var self = this;
    if (cb) (this.__cbs || (this.__cbs = [])).push(cb);
    if (this.__pending) return;
    this.__pending = true;
    var fired = false;
    function flush() {
      if (fired) return;
      fired = true;
      self.__pending = false;
      self.__render();
      var cbs = self.__cbs; self.__cbs = null;
      if (cbs) for (var i = 0; i < cbs.length; i++) { try { cbs[i](); } catch (e) { console.error(e); } }
      try { self.componentDidUpdate(); } catch (e) { console.error(e); }
    }
    (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(flush);
    setTimeout(flush, 100);
  };
})();
